import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as createWizardReducer from "containers/CreateWizard/reducer";

import AcademicChooseDataset from "components/CreateWizard/Academic/AcademicChooseDataset";
import DatasetViewContainer from "containers/View/Dataset";

const bId = "academicChooseDataset";

class AcademicChooseDatasetContainer extends React.PureComponent {
  handleUpdateSelection(selection) {
    const { updateSelection, generateNameAndUpdate, blueprintId, id } = this.props;

    return updateSelection(selection).then(() => {
      if (id === "new" && (blueprintId === "template" || blueprintId === "academic"))
        return generateNameAndUpdate(selection.value, blueprintId === "academic" ? undefined : "Optimized");
    });
  }

  handleUpdateSuccess(sel) {
    const { index, updateSuccess, updateStep } = this.props;

    updateStep(index + 1);

    return updateSuccess(sel);
  }

  render() {
    const { blueprintId, index } = this.props;

    return (
      <AcademicChooseDataset
        {...this.props}
        datasetView={
          <DatasetViewContainer blueprintId={blueprintId} onClick={(s) => this.handleUpdateSelection({ value: s })} />
        }
        updateSelection={(selection) => this.handleUpdateSelection({ value: selection })}
        updateSuccess={(success) => this.handleUpdateSuccess(success)}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSelection: (selection) =>
    dispatch(
      setupReducer.updateDatasetId(ownProps.id, selection.value, true, ownProps.index, ownProps.blueprintId, true)
    ),
  generateNameAndUpdate: (datasetId, message) =>
    dispatch(setupReducer.generateNameAndUpdate(ownProps.id, datasetId, message)),

  updateSuccess: (success) => {
    dispatch(setupReducer.updateSuccess(ownProps.runId, success));
    dispatch(setupReducer.checkCounts(ownProps.runId));
  },
  updateStep: (step) => dispatch(createWizardReducer.updateStep(step)),
  updateDescription: (desc) => dispatch(blueprintReducer.updateDescription(ownProps.id, desc)),

  updateEndState: (endState) => dispatch(setupReducer.updateEndState(ownProps.id, endState)),

  updateIgnored: (column, isIgnored) => dispatch(setupReducer.updateIgnored(ownProps.id, column, isIgnored))
});

const mapStateToProps = (state, ownProps) => {
  const selectedDataset = setupReducer.getDatasetFromSetup(state, ownProps.id);
  const outcomeType = selectedDataset ? setupReducer.getOutcomeType(state, ownProps.id) : null;
  return {
    selectedDataset: selectedDataset,
    outcomeType: outcomeType,

    selectedSuccess: setupReducer.getSuccess(state, ownProps.id),
    successOptions: setupReducer.getSuccessOptions(state, ownProps.id),

    step: createWizardReducer.getStep(state),

    correlations: setupReducer.getCorrelationsFromDataset(state, ownProps.id),
    ignored: setupReducer.getIgnored(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(AcademicChooseDatasetContainer);
